define('modules/Product/ProductCodes',[
    'jquery',
    'global/all',
    './ProductCodesService'
], function ($, Roc, ProductCodesService) {
    'use strict';

var hawkSearchUrl = null;
    var productIds = null;

    var selectors = {
        downloadProductCodesBtn: 'button[data-roc-action="downloadProductCodes"]'
    }

    function updateDisplayOfButton() {
        if (productIds.length > 0) {
            $(selectors.downloadProductCodesBtn).show();
        } else {
            $(selectors.downloadProductCodesBtn).hide();
        }
    }

    function downloadButtonClickedEvt() {
        Roc.UI.siteBody
            .off('click', selectors.downloadProductCodesBtn)
            .on('click', selectors.downloadProductCodesBtn, function (e) {
                e.preventDefault();
                if (productIds === null || productIds.length === 0) {
                    return;
                }

                Roc.Core.lockButton(selectors.downloadProductCodesBtn);
                ProductCodesService.downloadProductCodes(productIds).then(function(response) {
                        Roc.Extensions.downloadFile(response.file, response.fileName);
                    },
                    function() {
                        Roc.UI.error(
                            'There was an error while trying to download product codes file. Please try again later.');
                    }).always(function() {
                        Roc.Core.releaseLockedButton(selectors.downloadProductCodesBtn);
                });
            });
    }

    function hawkSearchSearchCompletedEvt() {
        // there is no way to hook up to Hawk Search events to know when the search is performed or completed
        // the only way is to bind to ajaxComplete event and check URL of the request
        // if it is Hawk Search URL then the search was performed and response can be processed here
        // to check if there are any items and what are their ids
        $(document).bind('ajaxComplete', function (event, xhr, settings) {
            if (settings.url.indexOf(hawkSearchUrl) === 0) {
                if (xhr.status === 200 &&
                    xhr.responseJSON !== undefined &&
                    xhr.responseJSON !== null &&
                    xhr.responseJSON.itemCodes !== undefined &&
                    xhr.responseJSON.itemCodes !== null) {
                    productIds = xhr.responseJSON.itemCodes;
                } else {
                    productIds = [];
                }
                updateDisplayOfButton();
            }
        });
    }

    function bindEvents() {
        hawkSearchSearchCompletedEvt();
        downloadButtonClickedEvt();
    }

    function init(options) {
        hawkSearchUrl = options.searchUrl;
        productIds = options.productIds;

        bindEvents();
    }

    var ProductCodes = {
        init: init
    }

    Roc.Logger.debug('ProductCodes.js Loaded:', ProductCodes);

    return ProductCodes;
});
